import { createSelector } from 'reselect'
import Store from '../store/storeTypes'

const getTour = (s: Store) => s.tour

const getOpen = createSelector(getTour, tour => tour.open)
const getStep = createSelector(getTour, tour => tour.step)

export const tourSelectors = { getOpen, getStep }
